<template>
    <nio-alert
        :title="$t('global.errors.validationErrorTitle')"
        type="error"
        ref="alert"
        v-if="$errors.hasAny()"
    >
        <ul>
            <template v-for="field in $errors.all()">
                <li
                    :key="error"
                    v-text="error"
                    v-for="error in field"
                />
            </template>
        </ul>
    </nio-alert>
</template>

<script>
    export default {
        computed: {
            hasError() {
                return this.$errors.hasAny();
            },
        },

        watch: {
            hasError(newValue) {
                if (!newValue) {
                    return;
                }

                this.$nextTick(() => {
                    this.$refs.alert.$el.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest',
                    });
                });
            },
        },
    };
</script>
